import { Box, Grid, Text } from '@src/shared/ui';
import React from 'react';

export const AlertInfo: React.FC = () => {
  return (
    <Box
      className={`
      w-full
      flex
      bg-secondary-10
    `}
    >
      <Grid>
        <Box
          className={`
            w-full
            flex
            flex-row
            items-start
            my-4
            col-span-4
            sm:col-span-8
            md:col-start-1
            md:col-span-12
            auto-rows-auto
          `}
        >
          <img
            src='/padlock-icon.svg'
            rel='icone de cadeado'
            className={`
            mr-3
          `}
          />
          <Text className='text-sm sm:text-base'>
            Você está em um ambiente seguro, somos parceiros oficiais da GOL
            Linhas Aéreas.
          </Text>
        </Box>
      </Grid>
    </Box>
  );
};
